export const ANALYTICS_DELETED_ISSUE_DEPENDENCY_LINK = 'issueDependencyLink deleted';
